//本地引入
import Layout from "@/layout/index.vue";

//公共库
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

//使用路由
Vue.use(VueRouter);

//-------------------------- 路由配置 --------------------------
/**
 * 动态路由
 */
export const asyncRoutes: RouteConfig[] = [
  //主页
  {
    //基本信息
    path: "/",
    component: Layout,
    redirect: "/dashboard",

    //子页面
    children: [
      {
        //基本信息
        path: "dashboard",
        name: "Dashboard",
        component: () => import("@/views/base/dashboard/index.vue"),

        //参数
        meta: {
          //标题
          title: "主页",

          //基本信息
          affix: true,
          noCache: false,
          ignorable: true,
          icon: "dashboard",
          routeList: ["/adm/data/home/page"],
        },
      },
    ],
  },

  //管理员
  {
    //基本信息
    component: Layout,
    path: "/trimo/admin",
    redirect: "/trimo/admin/index",

    //参数
    meta: {
      //基本信息
      icon: "user",
      roles: ["admin"],
      alwaysShow: true,
      title: "管理员",
    },

    //子页面
    children: [
      //管理员账号
      {
        //基本信息
        name: "User",
        path: "index",
        component: () => import("@/views/trimo/admin/index.vue"),

        //参数
        meta: {
          //基本信息
          noCache: true,
          title: "管理员账号",
          routeList: ["/adm/manage/get"],
        },
      },

      //角色权限管理
      {
        //基本信息
        name: "Permission",
        path: "permission",
        component: () => import("@/views/trimo/admin/permission.vue"),

        //参数
        meta: {
          //基本信息
          noCache: true,
          title: "角色权限管理",
          routeList: ["/adm/manage/getRole"],
        },
      },
    ],
  },

  //会员中心
  {
    //基本信息
    component: Layout,
    path: "/trimo/player",
    redirect: "/trimo/player/index",

    //参数
    meta: {
      //基本信息
      icon: "people",
      title: "会员中心",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //玩家列表
      {
        //基本信息
        path: "index",
        name: "Player",
        component: () => import("@/views/trimo/player/index.vue"),

        //参数
        meta: {
          noCache: false,
          title: "玩家列表",
          routeList: ["/adm/auth/getType", "/adm/user/list"],
        },
      },

      //公会列表
      {
        //基本信息
        path: "union_list",
        name: "union_list",
        component: () => import("@/views/trimo/player/union_list.vue"),

        //参数
        meta: {
          noCache: false,
          title: "公会列表",
          routeList: ["/adm/user/getUnion"],
        },
      },

      //博主审核列表
      {
        //基本信息
        path: "blogger_list",
        name: "blogger_list",
        component: () => import("@/views/trimo/player/blogger_list.vue"),

        //参数
        meta: {
          noCache: false,
          title: "博主审核列表",
          routeList: ["/adm/user/blogger/list"],
        },
      },

      //用户认证审核列表
      {
        //基本信息
        path: "certified_list",
        name: "certified_list",
        component: () => import("@/views/trimo/player/certified_list.vue"),

        //参数
        meta: {
          noCache: false,
          title: "用户认证审核列表",
          routeList: ["/adm/user/certified/list"],
        },
      },
    ],
  },

  //道具管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/item",
    redirect: "/trimo/item/gift_set",

    //参数
    meta: {
      icon: "icon",
      roles: ["admin"],
      alwaysShow: true,
      title: "道具管理",
    },

    //子页面
    children: [
      //礼包设置
      {
        //基本信息
        path: "gift_set",
        name: "gift_set",
        component: () => import("@/views/trimo/item/gift_set.vue"),

        //参数
        meta: {
          noCache: false,
          title: "礼包设置",
          routeList: ["/adm/shop/gift/list", "/adm/ledger/propconf/all"],
        },
      },

      //礼包发放
      {
        //基本信息
        path: "gift_send",
        name: "gift_send",
        component: () => import("@/views/trimo/item/gift_send.vue"),

        //参数
        meta: {
          noCache: false,
          title: "礼包发放",
          routeList: ["/adm/shop/gift/all", "/adm/shop/gift/send/list"],
        },
      },

      //道具属性
      {
        //基本信息
        path: "item_prop",
        name: "item_prop",
        component: () => import("@/views/trimo/item/item_prop.vue"),

        //参数
        meta: {
          noCache: false,
          title: "道具属性",
          routeList: ["/adm/shop/propmodelconf/list"],
        },
      },

      //道具资源
      {
        //基本信息
        path: "item_res_conf",
        name: "item_res_conf",
        component: () => import("@/views/trimo/item/item_res_conf.vue"),

        //参数
        meta: {
          noCache: false,
          title: "道具资源",
          routeList: ["/adm/shop/giftconf/list", "/adm/shop/propmodelconf/list"],
        },
      },

      //道具赠送
      {
        //基本信息
        path: "item_send",
        name: "item_send",
        component: () => import("@/views/trimo/item/item_send.vue"),

        //参数
        meta: {
          noCache: false,
          title: "道具赠送",
          routeList: ["/adm/ledger/propconf/all", "/adm/shop/gift/send"],
        },
      },

      //背包查询
      {
        //基本信息
        path: "back_pack",
        name: "back_pack",
        component: () => import("@/views/trimo/item/back_pack.vue"),

        //参数
        meta: {
          noCache: false,
          title: "背包查询",
          routeList: ["/adm/supervise/user/backpack/list"],
        },
      },

      //道具列表
      {
        path: "item_conf",
        name: "item_conf",
        component: () => import("@/views/trimo/item/item_conf.vue"),

        //参数
        meta: {
          noCache: false,
          title: "道具列表",
          routeList: ["/adm/user/blogger/level/conf", "/adm/shop/giftconf/list", "/adm/shop/propconf/relation/model"],
        },
      },

      //领取记录
      {
        path: "gift_record",
        name: "gift_record",
        component: () => import("@/views/trimo/item/gift_record.vue"),

        //参数
        meta: {
          noCache: false,
          title: "领取记录",
          routeList: ["/adm/ledger/giftcode/get/record"],
        },
      },

      //道具存量统计
      {
        path: "gift_statistics",
        name: "gift_statistics",
        component: () => import("@/views/trimo/item/gift_statistics.vue"),

        //参数
        meta: {
          noCache: false,
          title: "道具存量统计",
          routeList: ["/adm/data/prop/total"],
        },
      },

      //道具分类
      {
        path: "prop_cat",
        name: "prop_cat",
        component: () => import("@/views/trimo/item/prop_cat.vue"),

        //参数
        meta: {
          noCache: false,
          title: "道具分类",
          routeList: ["/adm/shop/prop/cat/list", "/adm/system/category/group/list"],
        },
      },

      //表情包管理
      {
        path: "prop_sticker_list",
        name: "prop_sticker_list",
        component: () => import("@/views/trimo/item/prop_sticker_list.vue"),

        //参数
        meta: {
          noCache: false,
          title: "表情包管理",
          routeList: ["/adm/shop/prop/sticker/list", "/adm/shop/prop/sticker/save", "/adm/shop/prop/sticker/remove"],
        },
      },
    ],
  },

  //商城管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/mall",
    redirect: "/trimo/mall/mall_diamond",

    //参数
    meta: {
      //基本信息
      icon: "shopping",
      roles: ["admin"],
      alwaysShow: true,
      title: "商城管理",
    },

    //子页面
    children: [
      //钻石商城
      {
        //基本信息
        path: "mall_diamond",
        name: "mall_diamond",
        component: () => import("@/views/trimo/mall/mall_diamond.vue"),

        //参数
        meta: {
          noCache: false,
          title: "钻石商城",
          routeList: ["/adm/system/category/group/list", "/adm/shop/propconf/list", "/adm/shop/mall/list"],
        },
      },

      //互动币商城
      {
        //基本信息
        path: "mall_coin",
        name: "mall_coin",
        component: () => import("@/views/trimo/mall/mall_coin.vue"),

        //参数
        meta: {
          noCache: false,
          title: "互动币商城",
          routeList: ["/adm/system/category/group/list", "/adm/shop/propconf/list", "/adm/shop/mall/list"],
        },
      },
    ],
  },

  //任务系统
  {
    //基本信息
    component: Layout,
    path: "/trimo/task",
    redirect: "/trimo/task/task_daily",

    //参数
    meta: {
      //基本信息
      icon: "edit",
      roles: ["admin"],
      alwaysShow: true,
      title: "任务系统",
    },

    //子页面
    children: [
      //签到任务
      {
        //基本信息
        path: "task_daily",
        name: "task_daily",
        component: () => import("@/views/trimo/task/task_daily.vue"),

        //参数
        meta: {
          noCache: false,
          title: "签到任务",
          routeList: ["/adm/task/daily/list"],
        },
      },

      //新手任务
      {
        //基本信息
        path: "task_newbie",
        name: "task_newbie",
        component: () => import("@/views/trimo/task/task_newbie.vue"),

        //参数
        meta: {
          noCache: false,
          title: "新手任务",
          routeList: ["/adm/task/newbie/list"],
        },
      },

      //内测任务
      {
        //基本信息
        path: "task_beta",
        name: "task_beta",
        component: () => import("@/views/trimo/task/task_beta.vue"),

        //参数
        meta: {
          noCache: false,
          title: "内测任务",
          routeList: ["/adm/inner/test/list"],
        },
      },
    ],
  },

  //流水查询
  {
    //基本信息
    component: Layout,
    path: "/trimo/pipelining",
    redirect: "/trimo/pipelining/props_flow",

    //参数
    meta: {
      //基本信息
      icon: "search",
      roles: ["admin"],
      alwaysShow: true,
      title: "流水查询",
    },

    //子页面
    children: [
      //道具流水
      {
        //基本信息
        path: "props_flow",
        name: "props_flow",
        component: () => import("@/views/trimo/pipelining/props_flow.vue"),

        //参数
        meta: {
          noCache: true,
          title: "道具流水",
          routeList: ["/adm/ledger/propconf/all", "/adm/ledger/proptype/all", "/adm/ledger/prop/list"],
        },
      },

      //私信记录
      {
        //基本信息
        path: "private_letter",
        name: "private_letter",
        component: () => import("@/views/trimo/pipelining/private_letter.vue"),

        //参数
        meta: {
          noCache: true,
          title: "私信记录",
          routeList: ["/adm/ledger/chat/object", "/adm/ledger/chat/list"],
        },
      },

      //博主选配记录
      {
        //基本信息
        path: "blogger_match",
        name: "blogger_match",
        component: () => import("@/views/trimo/pipelining/blogger_match.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主选配记录",
          routeList: ["/adm/data/blogger/match"],
        },
      },

      //视频语音记录
      {
        //基本信息
        path: "voice_video",
        name: "voice_video",
        component: () => import("@/views/trimo/pipelining/voice_video.vue"),

        //参数
        meta: {
          noCache: true,
          title: "视频语音记录",
          routeList: ["/adm/ledger/rtc/list"],
        },
      },
    ],
  },

  //工作室
  {
    //基本信息
    component: Layout,
    path: "/trimo/studio",
    redirect: "/trimo/studio/blogger_credits",

    //参数
    meta: {
      //基本信息
      icon: "tree",
      title: "工作室",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //博主积分
      {
        //基本信息
        path: "blogger_credits",
        name: "blogger_credits",
        component: () => import("@/views/trimo/studio/blogger_credits.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主积分",
          routeList: ["/adm/data/blogger/score/list"],
        },
      },

      //成员审核
      {
        //基本信息
        path: "member_review",
        name: "member_review",
        component: () => import("@/views/trimo/studio/member_review.vue"),

        //参数
        meta: {
          noCache: true,
          title: "成员审核",
          routeList: ["/adm/user/union/apply/list"],
        },
      },

      //信誉点查询
      {
        //基本信息
        path: "credibility_points",
        name: "credibility_points",
        component: () => import("@/views/trimo/studio/credibility_points.vue"),

        //参数
        meta: {
          noCache: true,
          title: "信誉点查询",
          routeList: ["/adm/supervise/user/credit/list"],
        },
      },

      //工作室管理
      {
        //基本信息
        path: "studio_manage",
        name: "studio_manage",
        component: () => import("@/views/trimo/studio/studio_manage.vue"),

        //参数
        meta: {
          noCache: true,
          title: "工作室管理",
          routeList: ["/adm/user/blogger/level/conf", "/adm/user/union/auth/list", "/adm/user/union/manager/list"],
        },
      },
    ],
  },

  //消息管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/bulletin",
    redirect: "/trimo/bulletin/announcement",

    //参数
    meta: {
      //基本信息
      icon: "guide",
      roles: ["admin"],
      alwaysShow: true,
      title: "消息管理",
    },

    //子页面
    children: [
      //官方消息
      {
        //基本信息
        path: "announcement",
        name: "announcement",
        component: () => import("@/views/trimo/bulletin/announcement.vue"),

        //参数
        meta: {
          noCache: true,
          title: "官方消息",
          routeList: ["/adm/inbox/official/list"],
        },
      },

      //系统消息
      {
        //基本信息
        path: "systemNotify",
        name: "systemNotify",
        component: () => import("@/views/trimo/bulletin/system_notify.vue"),

        //参数
        meta: {
          noCache: true,
          title: "系统消息",
          routeList: ["/adm/inbox/official/sysmsg/list"],
        },
      },

      //消息代发
      {
        //基本信息
        path: "MsgSend",
        name: "MsgSend",
        component: () => import("@/views/trimo/bulletin/msg_send.vue"),

        //参数
        meta: {
          noCache: true,
          title: "消息代发",
          routeList: ["/adm/system/ry/msg/send/list"],
        },
      },

      //系统公告
      {
        //基本信息
        path: "system_notice",
        name: "system_notice",
        component: () => import("@/views/trimo/bulletin/system_notice.vue"),

        //参数
        meta: {
          noCache: true,
          title: "系统公告",
          routeList: ["/adm/system/notice/list"],
        },
      },
    ],
  },

  //大数据
  {
    //基本信息
    component: Layout,
    path: "/trimo/bigdata",
    redirect: "/trimo/bigdata/online_list",

    //参数
    meta: {
      //基本信息
      icon: "example",
      title: "大数据",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //在线列表
      {
        //基本信息
        path: "online_list",
        name: "online_list",
        component: () => import("@/views/trimo/bigdata/online_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "在线列表",
          routeList: ["/adm/data/user/list"],
        },
      },

      //在线人数
      {
        //基本信息
        path: "online_users",
        name: "online_users",
        component: () => import("@/views/trimo/bigdata/online_users.vue"),

        //参数
        meta: {
          noCache: true,
          title: "在线人数",
          routeList: ["/adm/data/user/onlinenum", "/adm/data/online/count/minute"],
        },
      },

      //在线时长统计
      {
        //基本信息
        path: "online_time",
        name: "online_time",
        component: () => import("@/views/trimo/bigdata/online_time.vue"),

        //参数
        meta: {
          noCache: true,
          title: "在线时长统计",
          routeList: ["/adm/data/user/online"],
        },
      },

      //【新】在线时长统计
      {
        //基本信息
        path: "new_online_time",
        name: "new_online_time",
        component: () => import("@/views/trimo/bigdata/new_online_time.vue"),

        //参数
        meta: {
          noCache: true,
          title: "【新】在线时长统计",
          routeList: ["/adm/data/user/online/duration/list"],
        },
      },

      //接通统计
      {
        //基本信息
        path: "connect_statistics",
        name: "connect_statistics",
        component: () => import("@/views/trimo/bigdata/connect_statistics.vue"),

        //参数
        meta: {
          noCache: false,
          title: "接通统计",
          routeList: ["/adm/data/blogger/connect"],
        },
      },

      //留存统计
      {
        //基本信息
        path: "retention",
        name: "retention",
        component: () => import("@/views/trimo/bigdata/retention.vue"),

        //参数
        meta: {
          noCache: true,
          title: "留存统计",
          routeList: ["/adm/data/user/reg/remain"],
        },
      },

      //钻石消耗统计
      {
        //基本信息
        path: "diamond_statistics",
        name: "diamond_statistics",
        component: () => import("@/views/trimo/bigdata/diamond_statistics.vue"),

        //参数
        meta: {
          noCache: true,
          title: "钻石消耗统计",
          routeList: ["/adm/data/user/diamond/list"],
        },
      },

      //支付报表
      {
        //基本信息
        path: "payment_statement",
        name: "payment_statement",
        component: () => import("@/views/trimo/bigdata/payment_statement.vue"),

        //参数
        meta: {
          noCache: true,
          title: "支付报表",
          routeList: ["/adm/data/recharge/list"],
        },
      },

      //活跃用户
      {
        //基本信息
        path: "active_user",
        name: "active_user",
        component: () => import("@/views/trimo/bigdata/active_user.vue"),

        //参数
        meta: {
          noCache: true,
          title: "活跃用户",
          routeList: ["/adm/data/user/active"],
        },
      },

      //广场查询
      {
        //基本信息
        path: "square_query",
        name: "square_query",
        component: () => import("@/views/trimo/bigdata/square_query.vue"),

        //参数
        meta: {
          noCache: true,
          title: "广场查询",
          routeList: ["/adm/data/blogger/square"],
        },
      },

      //新手72h优惠
      {
        //基本信息
        path: "newbie_offer",
        name: "newbie_offer",
        component: () => import("@/views/trimo/bigdata/newbie_offer.vue"),

        //参数
        meta: {
          noCache: true,
          title: "新手72h优惠",
          routeList: ["/adm/user/newbie/list"],
        },
      },

      //用户活跃时长
      {
        //基本信息
        path: "user_active_time",
        name: "user_active_time",
        component: () => import("@/views/trimo/bigdata/user_active_time.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户活跃时长",
          routeList: ["/adm/data/user/active/user_data_list"],
        },
      },

      //App界面停留统计
      {
        //基本信息
        path: "stay_statistics",
        name: "stay_statistics",
        component: () => import("@/views/trimo/bigdata/stay_statistics.vue"),

        //参数
        meta: {
          noCache: false,
          title: "APP界面停留统计",
          routeList: ["/adm/data/user/scene"],
        },
      },

      //首页博主泡泡记录
      {
        //基本信息
        path: "blogger_bubbles_log",
        name: "blogger_bubbles_log",
        component: () => import("@/views/trimo/bigdata/blogger_bubbles_log.vue"),

        //参数
        meta: {
          noCache: true,
          title: "首页博主泡泡记录",
          routeList: ["/adm/blogger/bubbles_log/chart"],
        },
      },

      //用户月卡记录
      {
        //基本信息
        path: "month_card_record",
        name: "month_card_record",
        component: () => import("@/views/trimo/bigdata/month_card_record.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户月卡记录",
          routeList: ["/adm/data/month_card/record/list"],
        },
      },
    ],
  },

  //用户管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/user",
    redirect: "/trimo/user/vip_list",

    //参数
    meta: {
      //基本信息
      icon: "peoples",
      roles: ["admin"],
      alwaysShow: true,
      title: "用户管理",
    },

    //子页面
    children: [
      //VIP列表
      {
        //基本信息
        name: "vip_list",
        path: "vip_list",
        component: () => import("@/views/trimo/user/vip_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "VIP列表",
          routeList: ["/adm/data/user/vip/list"],
        },
      },

      //用户列表
      {
        //基本信息
        name: "user_list",
        path: "user_list",
        component: () => import("@/views/trimo/user/user_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户列表",
          routeList: ["/adm/data/user/manager/list", "/adm/data/user/country/edit"],
        },
      },

      // //多巴用户
      // {
      //   //基本信息
      //   name: "user_risk",
      //   path: "user_risk",
      //   component: () => import("@/views/trimo/user/user_risk.vue"),

      //   //参数
      //   meta: {
      //     noCache: true,
      //     title: "多巴用户",
      //   },
      // },

      //记录查询
      {
        //基本信息
        path: "record_list",
        name: "record_list",
        component: () => import("@/views/trimo/user/record_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "记录查询",
          routeList: ["/adm/supervise/user/record/list"],
        },
      },

      //冻结记录
      {
        //基本信息
        path: "lock_list",
        name: "lock_list",
        component: () => import("@/views/trimo/user/lock_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "冻结记录",
          routeList: ["/adm/user/lock/list"],
        },
      },

      //聊天记录查询
      {
        //基本信息
        path: "chat_history",
        name: "chat_history",
        component: () => import("@/views/trimo/user/chat_history.vue"),

        //参数
        meta: {
          noCache: true,
          title: "聊天记录查询",
          routeList: ["/adm/supervise/risk/im/label/list", "/adm/supervise/user/chat/record/list"],
        },
      },

      //签到日志列表
      {
        //基本信息
        path: "sign_award_log",
        name: "sign_award_log",
        component: () => import("@/views/trimo/user/sign_award_log.vue"),

        //参数
        meta: {
          noCache: true,
          title: "签到日志列表",
          routeList: ["/adm/sign/log/list"],
        },
      },

      //签到奖励配置列表
      {
        //基本信息
        path: "sign_sward_set",
        name: "sign_sward_set",
        component: () => import("@/views/trimo/user/sign_sward_set.vue"),

        //参数
        meta: {
          noCache: true,
          title: "签到奖励配置列表",
          routeList: ["/adm/shop/gift/all", "/adm/ledger/propconf/all", "/adm/sign/award/set/list"],
        },
      },

      //用户行为上报记录
      {
        //基本信息
        path: "user_action_peport",
        name: "user_action_peport",
        component: () => import("@/views/trimo/user/user_action_peport.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户行为上报记录",
          routeList: ["/adm/data/user_action_report/list"],
        },
      },

      //黑名单列表
      {
        //基本信息
        path: "black_list",
        name: "black_list",
        component: () => import("@/views/trimo/user/black_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "黑名单列表",
          routeList: ["/adm/user/blacklist/list", "/adm/user/blacklist/add", "/adm/user/blacklist/remove"],
        },
      },

      //用户资料
      {
        //基本信息
        path: "material_list",
        name: "material_list",
        component: () => import("@/views/trimo/user/material_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户资料",
          routeList: ["/adm/data/user/material/list", "/adm/user/material/save"],
        },
      },

      //信誉评分
      {
        //基本信息
        path: "im_score",
        name: "im_score",
        component: () => import("@/views/trimo/user/im_score.vue"),

        //参数
        meta: {
          noCache: true,
          title: "信誉评分",
          routeList: ["/adm/user/im/score/list", "/adm/user/im/score/save", "/adm/user/im/score/log/list"],
        },
      },
    ],
  },

  //博主管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/blogger",
    redirect: "/trimo/blogger/feedback",

    //参数
    meta: {
      //基本信息
      icon: "blogger1",
      roles: ["admin"],
      alwaysShow: true,
      title: "博主管理",
    },

    //子页面
    children: [
      //博主反馈
      {
        //基本信息
        path: "feedback",
        name: "feedback",
        component: () => import("@/views/trimo/blogger/feedback.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主反馈",
          routeList: ["/adm/data/user/feedback/list"],
        },
      },

      //博主设置
      {
        //基本信息
        path: "blogger_set",
        name: "blogger_set",
        component: () => import("@/views/trimo/blogger/blogger_set.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主设置",
          routeList: ["/adm/blogger/set/list"],
        },
      },

      //缘分伴侣
      {
        //基本信息
        path: "companion",
        name: "companion",
        component: () => import("@/views/trimo/blogger/companion.vue"),

        //参数
        meta: {
          noCache: true,
          title: "缘分伴侣",
          routeList: ["/adm/blogger/companion/list"],
        },
      },

      //博主引导设置
      {
        //基本信息
        path: "guide_set",
        name: "guide_set",
        component: () => import("@/views/trimo/blogger/guide_set.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主引导设置",
          routeList: ["/adm/blogger/guide/list"],
        },
      },

      //博主引导记录
      {
        //基本信息
        path: "guide_record",
        name: "guide_record",
        component: () => import("@/views/trimo/blogger/guide_record.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主引导记录",
          routeList: ["/adm/blogger/guide/log/list"],
        },
      },

      //博主推荐记录
      {
        //基本信息
        path: "blogger_recommend_record",
        name: "blogger_recommend_record",
        component: () => import("@/views/trimo/blogger/recommend_record.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主推荐记录",
          routeList: ["/adm/blogger/push/log/list"],
        },
      },

      //博主指令轮盘
      {
        //基本信息
        path: "blogger_game_wheel",
        name: "blogger_game_wheel",
        component: () => import("@/views/trimo/blogger/game_wheel.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主指令轮盘",
          routeList: ["/adm/game/wheel/list"],
        },
      },

      //博主默认消息
      {
        //基本信息
        path: "blogger_default_call",
        name: "blogger_default_call",
        component: () => import("@/views/trimo/blogger/default_call.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主默认消息",
          routeList: ["/adm/blogger/defaultcall/list"],
        },
      },

      //博主价格设置
      {
        //基本信息
        path: "blogger_price_set",
        name: "blogger_price_set",
        component: () => import("@/views/trimo/blogger/price_set.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主价格设置",
          routeList: ["/adm/blogger/price/list"],
        },
      },

      //博主活跃时长
      {
        //基本信息
        path: "active_duration",
        name: "active_duration",
        component: () => import("@/views/trimo/blogger/active_duration.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主活跃时长",
          routeList: ["/adm/blogger/active/duration/list"],
        },
      },

      //博主活跃记录
      {
        //基本信息
        path: "active_log",
        name: "active_log",
        component: () => import("@/views/trimo/blogger/active_log.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主活跃记录",
          routeList: ["/adm/blogger/active/log/list"],
        },
      },

      //视频开关时长
      {
        //基本信息
        path: "video_switch_duration",
        name: "video_switch_duration",
        component: () => import("@/views/trimo/blogger/video_switch_duration.vue"),

        //参数
        meta: {
          noCache: true,
          title: "视频开关时长",
          routeList: ["/adm/blogger/video/switch/duration/list"],
        },
      },

      //视频开关记录
      {
        //基本信息
        path: "video_switch_log",
        name: "video_switch_log",
        component: () => import("@/views/trimo/blogger/video_switch_log.vue"),

        //参数
        meta: {
          noCache: true,
          title: "视频开关记录",
          routeList: ["/adm/blogger/video/switch/log/list"],
        },
      },

      //博主充值推送记录
      {
        //基本信息
        path: "blogger_recharge_record",
        name: "blogger_recharge_record",
        component: () => import("@/views/trimo/blogger/recharge_record.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主充值推送记录",
          routeList: ["/adm/blogger/recharge/push/list"],
        },
      },

      //博主回复效率统计
      {
        //基本信息
        path: "statistics_reply_count",
        name: "statistics_reply_count",
        component: () => import("@/views/trimo/blogger/statistics_reply_count.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主回复效率统计",
          routeList: ["/adm/data/blogger_reply_count/list"],
        },
      },

      //博主通话效率统计
      {
        //基本信息
        path: "statistics_call_count",
        name: "statistics_call_count",
        component: () => import("@/views/trimo/blogger/statistics_call_count.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主通话效率统计",
          routeList: ["/adm/data/blogger_call_count/list"],
        },
      },

      //博主帖子推荐配置列表
      {
        //基本信息
        path: "recommend_set",
        name: "recommend_set",
        component: () => import("@/views/trimo/blogger/post_recommend_set.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主帖子推荐配置列表",
          routeList: ["/adm/blogger/recommend/list"],
        },
      },

      //博主帖子推荐记录列表
      {
        //基本信息
        path: "recommend_record",
        name: "recommend_record",
        component: () => import("@/views/trimo/blogger/post_recommend_record.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主帖子推荐记录列表",
          routeList: ["/adm/blogger/recommend_log/list"],
        },
      },

      //博主帖子推荐用户列表
      {
        //基本信息
        path: "recommend_user_list",
        name: "recommend_user_list",
        component: () => import("@/views/trimo/blogger/post_recommend_user_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主帖子推荐用户列表",
          routeList: ["/adm/blogger/recommend_user/list"],
        },
      },

      //多巴博主标签配置列表
      {
        //基本信息
        path: "risk_blogger_label_list",
        name: "risk_blogger_label_list",
        component: () => import("@/views/trimo/blogger/risk_blogger_label_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "多巴博主标签配置列表",
          routeList: ["/adm/blogger/risk/label/list"],
        },
      },

      //订阅关系列表
      {
        //基本信息
        path: "dy_user",
        name: "dy_user",
        component: () => import("@/views/trimo/blogger/dy_user.vue"),

        //参数
        meta: {
          noCache: true,
          title: "订阅关系列表",
          routeList: ["/adm/dy/user/list"],
        },
      },

      //订阅记录列表
      {
        //基本信息
        path: "dy_log",
        name: "dy_log",
        component: () => import("@/views/trimo/blogger/dy_log.vue"),

        //参数
        meta: {
          noCache: true,
          title: "订阅记录列表",
          routeList: ["/adm/dy/log/list"],
        },
      },

      //订阅奖励列表
      {
        //基本信息
        path: "dy_award",
        name: "dy_award",
        component: () => import("@/views/trimo/blogger/dy_award.vue"),

        //参数
        meta: {
          noCache: true,
          title: "订阅奖励列表",
          routeList: ["/adm/dy/award/list"],
        },
      },

      //代运营管理
      {
        //基本信息
        path: "assist_manager",
        name: "assist_manager",
        component: () => import("@/views/trimo/blogger/assist_manager.vue"),

        //参数
        meta: {
          noCache: true,
          title: "代运营管理",
          routeList: ["/adm/manage/assist/list", "/adm/assist/blogger/list"],
        },
      },

      //博主匹配记录
      {
        //基本信息
        path: "user_match",
        name: "user_match",
        component: () => import("@/views/trimo/blogger/user_match.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主匹配记录",
          routeList: ["/adm/blogger/user/match/log/list"],
        },
      },

      //通话邀请
      {
        //基本信息
        path: "invite_call",
        name: "invite_call",
        component: () => import("@/views/trimo/blogger/invite_call.vue"),

        //参数
        meta: {
          noCache: true,
          title: "通话邀请",
          routeList: ["/adm/blogger/invite/call/list"],
        },
      },

      //每日积分
      {
        //基本信息
        path: "day_score",
        name: "day_score",
        component: () => import("@/views/trimo/blogger/day_score.vue"),

        //参数
        meta: {
          noCache: true,
          title: "每日积分",
          routeList: ["/adm/blogger/day/score/list"],
        },
      },

      //博主流量
      {
        //基本信息
        path: "blogger_flow",
        name: "blogger_flow",
        component: () => import("@/views/trimo/blogger/blogger_flow.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主流量",
          routeList: ["/adm/blogger/flow/list"],
        },
      },

      //跨区博主推荐
      {
        //基本信息
        path: "across_recommend",
        name: "across_recommend",
        component: () => import("@/views/trimo/blogger/across_recommend.vue"),

        //参数
        meta: {
          noCache: true,
          title: "跨区博主推荐",
          routeList: ["/adm/blogger/across/recommend/list", "/adm/blogger/across/recommend/save", "/adm/blogger/across/recommend/detail"],
        },
      },

      //互动统计列表
      {
        //基本信息
        path: "chat_count_list",
        name: "chat_count_list",
        component: () => import("@/views/trimo/blogger/chat_count_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "互动统计列表",
          routeList: ["/adm/blogger/chat/count/list"],
        },
      },
    ],
  },

  //充提管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/recharge",
    redirect: "/trimo/recharge/record",

    //参数
    meta: {
      //基本信息
      roles: ["admin"],
      alwaysShow: true,
      title: "充提管理",
      icon: "withdrawal",
    },

    //子页面
    children: [
      //线下充值
      {
        //基本信息
        path: "recharge_pay",
        name: "recharge_pay",
        component: () => import("@/views/trimo/recharge/recharge_pay.vue"),

        //参数
        meta: {
          noCache: true,
          title: "线下充值",
          routeList: ["/adm/user/info", "/adm/ledger/recharge/pay"],
        },
      },

      //充值记录
      {
        //基本信息
        path: "recharge_record",
        name: "recharge_record",
        component: () => import("@/views/trimo/recharge/recharge_record.vue"),

        //参数
        meta: {
          noCache: true,
          title: "充值记录",
          routeList: ["/adm/ledger/recharge/list"],
        },
      },

      //用户充值统计
      {
        //基本信息
        path: "recharge_statistics",
        name: "recharge_statistics",
        component: () => import("@/views/trimo/recharge/recharge_statistics.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户充值统计",
          routeList: ["/adm/data/user_pay_statistics/list"],
        },
      },

      //AppsFlyer充值
      {
        //基本信息
        path: "apps_flyer_recharge",
        name: "apps_flyer_recharge",
        component: () => import("@/views/trimo/recharge/apps_flyer_recharge.vue"),

        //参数
        meta: {
          noCache: true,
          title: "AppsFlyer充值",
          routeList: ["/adm/ledger/appsflyer/recharge/list"],
        },
      },
    ],
  },

  //用户监管
  {
    //基本信息
    component: Layout,
    path: "/trimo/supervise",
    redirect: "/trimo/supervise/square",

    //参数
    meta: {
      //基本信息
      icon: "safety",
      roles: ["admin"],
      alwaysShow: true,
      title: "用户监管",
    },

    //子页面
    children: [
      //广场监管
      {
        //基本信息
        path: "square",
        name: "square",
        component: () => import("@/views/trimo/supervise/square.vue"),

        //参数
        meta: {
          noCache: true,
          title: "广场监管",
          routeList: ["/adm/supervise/user/daily"],
        },
      },

      //相册监管
      {
        //基本信息
        path: "album",
        name: "album",
        component: () => import("@/views/trimo/supervise/album.vue"),

        //参数
        meta: {
          noCache: true,
          title: "相册监管",
          routeList: ["/adm/supervise/user/photo"],
        },
      },

      //头像监管
      {
        //基本信息
        path: "avatar",
        name: "avatar",
        component: () => import("@/views/trimo/supervise/avatar.vue"),

        //参数
        meta: {
          noCache: true,
          title: "头像监管",
          routeList: ["/adm/supervise/user/avatar"],
        },
      },

      //在线监管
      {
        //基本信息
        path: "online",
        name: "online",
        component: () => import("@/views/trimo/supervise/online.vue"),

        //参数
        meta: {
          noCache: true,
          title: "在线监管",
          routeList: ["/adm/supervise/risk/medium/list", "/adm/supervise/risk/medium/label/list"],
        },
      },

      //IM监管
      {
        //基本信息
        path: "im_supervise",
        name: "im_supervise",
        component: () => import("@/views/trimo/supervise/im_supervise.vue"),

        //参数
        meta: {
          noCache: true,
          title: "IM监管",
          routeList: ["/adm/supervise/risk/im/label/list", "/adm/supervise/risk/im/list"],
        },
      },

      //【新】IM监管
      {
        //基本信息
        path: "im_supervise_new",
        name: "im_supervise_new",
        component: () => import("@/views/trimo/supervise/im_supervise_new.vue"),

        //参数
        meta: {
          noCache: true,
          title: "【新】IM监管",
          routeList: ["/adm/system/words/category", "/adm/supervise/risk/im/log/list"],
        },
      },
    ],
  },

  //标签管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/tag",
    redirect: "/trimo/tag/tag_library",

    //参数
    meta: {
      //基本信息
      icon: "tag",
      title: "标签管理",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //标签管理
      {
        //基本信息
        path: "tags_manager",
        name: "tags_manager",
        component: () => import("@/views/trimo/tag/tags_manager.vue"),

        //参数
        meta: {
          noCache: true,
          title: "标签管理",
          routeList: ["/adm/tag/list"],
        },
      },

      //用户标签管理
      {
        //基本信息
        path: "user_tags_manager",
        name: "user_tags_manager",
        component: () => import("@/views/trimo/tag/user_tags_manager.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户标签管理",
          routeList: ["/adm/tag/list", "/adm/user/tag/list"],
        },
      },

      //博主标签管理
      {
        //基本信息
        path: "blogger_tags_manager",
        name: "blogger_tags_manager",
        component: () => import("@/views/trimo/tag/blogger_tags_manager.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主标签管理",
          routeList: ["/adm/tag/list", "/adm/user/tag/list"],
        },
      },

      //风控标签管理
      {
        //基本信息
        path: "tags_library",
        name: "tags_library",
        component: () => import("@/views/trimo/tag/tags_library.vue"),

        //参数
        meta: {
          noCache: true,
          title: "风控标签管理",
          routeList: ["/adm/supervise/user/labelgroup/list", "/adm/supervise/user/label/list"],
        },
      },

      //风控标签组管理
      {
        //基本信息
        path: "tagsgroup",
        name: "tagsgroup",
        component: () => import("@/views/trimo/tag/tags_group.vue"),

        //参数
        meta: {
          noCache: true,
          title: "风控标签组管理",
          routeList: ["/adm/supervise/user/labelgroup/list"],
        },
      },

      //风控用户标签查询
      {
        //基本信息
        path: "tags_search",
        name: "tags_search",
        component: () => import("@/views/trimo/tag/tags_search.vue"),

        //参数
        meta: {
          noCache: true,
          title: "风控用户标签查询",
          routeList: ["/adm/supervise/user/labelgroup/list", "/adm/supervise/user/label/list", "/adm/supervise/user/risk/list"],
        },
      },
    ],
  },

  //行为查询
  {
    //基本信息
    component: Layout,
    path: "/trimo/behavior",
    redirect: "/trimo/behavior/follow",

    //参数
    meta: {
      //基本信息
      roles: ["admin"],
      alwaysShow: true,
      title: "行为查询",
      icon: "user-search",
    },

    //子页面
    children: [
      //关注查询
      {
        //基本信息
        path: "follow",
        name: "follow",
        component: () => import("@/views/trimo/behavior/follow.vue"),

        //参数
        meta: {
          noCache: true,
          title: "关注查询",
          routeList: ["/adm/supervise/user/follow/list"],
        },
      },

      //举报查询
      {
        //基本信息
        path: "report",
        name: "report",
        component: () => import("@/views/trimo/behavior/report.vue"),

        //参数
        meta: {
          noCache: true,
          title: "举报查询",
          routeList: ["/adm/supervise/user/report/list"],
        },
      },

      //黑名单查询
      {
        //基本信息
        path: "black_list",
        name: "black_list",
        component: () => import("@/views/trimo/behavior/black_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "黑名单查询",
          routeList: ["/adm/supervise/user/black/list"],
        },
      },

      //熟悉度亲密度
      {
        //基本信息
        path: "familiarity_intimacy",
        name: "familiarity_intimacy",
        component: () => import("@/views/trimo/behavior/familiarity.vue"),

        //参数
        meta: {
          noCache: true,
          title: "熟悉度亲密度",
          routeList: ["/adm/supervise/user/popularity/list"],
        },
      },

      //用户操作查询
      {
        //基本信息
        path: "user_action",
        name: "user_action",
        component: () => import("@/views/trimo/behavior/user_action.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户操作查询",
          routeList: ["/adm/supervise/user/event/type", "/adm/supervise/user/event/list"],
        },
      },
    ],
  },

  //活动设置
  {
    //基本信息
    component: Layout,
    path: "/trimo/activity",
    redirect: "/trimo/activity/hong_bao_yu",

    //参数
    meta: {
      //基本信息
      roles: ["admin"],
      alwaysShow: true,
      title: "活动设置",
      icon: "activity",
    },

    //子页面
    children: [
      //红包雨
      {
        //基本信息
        path: "hong_bao_yu",
        name: "hong_bao_yu",
        component: () => import("@/views/trimo/activity/hong_bao_yu.vue"),

        //参数
        meta: {
          noCache: true,
          title: "红包雨",
          routeList: ["/adm/ledger/propconf/all", "/adm/hby/list"],
        },
      },

      //礼物墙
      {
        //基本信息
        path: "gift_wall",
        name: "gift_wall",
        component: () => import("@/views/trimo/activity/gift_wall.vue"),

        //参数
        meta: {
          noCache: true,
          title: "礼物墙",
          routeList: ["/adm/gift_wall/prop/all", "/adm/gift_wall/list"],
        },
      },

      //女神大赛
      {
        //基本信息
        path: "goddess_contest",
        name: "goddess_contest",
        component: () => import("@/views/trimo/activity/goddess_contest.vue"),

        //参数
        meta: {
          noCache: true,
          title: "女神大赛",
          routeList: ["/adm/ledger/propconf/all", "/adm/goddess/contest/list"],
        },
      },

      //充值抽奖活动
      {
        //基本信息
        path: "recharge_lottery",
        name: "Recharge recharge_lottery",
        component: () => import("@/views/trimo/activity/recharge_lottery.vue"),

        //参数
        meta: {
          noCache: true,
          title: "充值抽奖活动",
          routeList: ["/adm/active/getBanner"],
        },
      },

      //KOL活动管理
      {
        //基本信息
        path: "kol_manager",
        name: "kol_manager",
        component: () => import("@/views/trimo/activity/kol_manager.vue"),

        //参数
        meta: {
          noCache: true,
          title: "KOL活动管理",
          routeList: ["/adm/live/activity/list"],
        },
      },

      //H5活动管理
      {
        //基本信息
        path: "h5_manager",
        name: "h5_manager",
        component: () => import("@/views/trimo/activity/h5_manager.vue"),

        //参数
        meta: {
          noCache: true,
          title: "H5活动管理",
          routeList: ["/adm/ledger/propconf/all", "/adm/h5_activity/list"],
        },
      },

      //PK赛管理
      {
        //基本信息
        path: "pk_race",
        name: "pk_race",
        component: () => import("@/views/trimo/activity/pk_race.vue"),

        //参数
        meta: {
          noCache: true,
          title: "PK赛管理",
          routeList: ["/adm/pk/race/list"],
        },
      },

      //心声驿站
      {
        //基本信息
        path: "xsyz_list",
        name: "xsyz_list",
        component: () => import("@/views/trimo/activity/xsyz_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "心声驿站",
          routeList: ["/adm/xsyz/list"],
        },
      },

      //守护骑士
      {
        //基本信息
        path: "shqs_log_list",
        name: "shqs_log_list",
        component: () => import("@/views/trimo/activity/shqs_log_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "守护骑士",
          routeList: ["/adm/shqs/log/list"],
        },
      },
    ],
  },

  //推广查询
  {
    //基本信息
    component: Layout,
    path: "/trimo/promotion",
    redirect: "/trimo/promotion/promotion",

    //参数
    meta: {
      //基本信息
      title: "推广查询",
      roles: ["admin"],
      alwaysShow: true,
      icon: "promotion",
    },

    //子页面
    children: [
      //推广佣金查询
      {
        //基本信息
        path: "commission_inquiry",
        name: "commission_inquiry",
        component: () => import("@/views/trimo/promotion/promotion.vue"),

        //参数
        meta: {
          noCache: true,
          title: "推广佣金查询",
          routeList: ["/adm/promotion/external/user/list"],
        },
      },

      //推广佣金设置
      {
        //基本信息
        path: "commission_set",
        name: "commission_set",
        component: () => import("@/views/trimo/promotion/promotion_set.vue"),

        //参数
        meta: {
          noCache: true,
          title: "推广佣金设置",
          routeList: ["/adm/shop/gift/all", "/adm/promotion/external/list"],
        },
      },

      //用户推广查询
      {
        //基本信息
        path: "user_promotion",
        name: "user_promotion",
        component: () => import("@/views/trimo/promotion/user_promotion.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户推广查询",
          routeList: ["/adm/promote/user/list"],
        },
      },

      //用户推广设置
      {
        //基本信息
        path: "user_promotion_set",
        name: "user_promotion_set",
        component: () => import("@/views/trimo/promotion/user_promotion_set.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户推广设置",
          routeList: ["/adm/promote/user/cfg/list"],
        },
      },

      //用户推广奖励记录
      {
        //基本信息
        path: "user_promotion_record",
        name: "user_promotion_record",
        component: () => import("@/views/trimo/promotion/user_promotion_record.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户推广奖励记录",
          routeList: ["/adm/promote/user/award/list"],
        },
      },

      //博主推广查询
      {
        //基本信息
        path: "blogger_promotion",
        name: "blogger_promotion",
        component: () => import("@/views/trimo/promotion/blogger_promotion.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主推广查询",
          routeList: ["/adm/promote/blogger/user/list"],
        },
      },

      //博主推广设置
      {
        //基本信息
        path: "blogger_promotion_set",
        name: "blogger_promotion_set",
        component: () => import("@/views/trimo/promotion/blogger_promotion_set.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主推广设置",
          routeList: ["/adm/promote/blogger/cfg/list"],
        },
      },

      //博主推广奖励记录
      {
        //基本信息
        path: "blogger_promotion_record",
        name: "blogger_promotion_record",
        component: () => import("@/views/trimo/promotion/blogger_promotion_record.vue"),

        //参数
        meta: {
          noCache: true,
          title: "博主推广奖励记录",
          routeList: ["/adm/promote/blogger/award/list"],
        },
      },
    ],
  },

  //渠道查询
  {
    //基本信息
    component: Layout,
    path: "/trimo/channel",
    redirect: "/trimo/channel/channel_list",

    //参数
    meta: {
      //基本信息
      icon: "channel",
      title: "渠道查询",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //渠道列表
      {
        //基本信息
        path: "channel_list",
        name: "channel_list",
        component: () => import("@/views/trimo/channel/channel_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "渠道列表",
          routeList: ["/adm/channel/all"],
        },
      },
    ],
  },

  //客服管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/service",
    redirect: "/trimo/customer/customer_list",

    //参数
    meta: {
      //基本信息
      icon: "customer",
      title: "客服管理",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //客服列表
      {
        //基本信息
        path: "customer_list",
        name: "customer_list",
        component: () => import("@/views/trimo/customer/customer_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "客服列表",
          routeList: ["/adm/customer/tag/list", "/adm/customer/list"],
        },
      },

      //客服标签
      {
        //基本信息
        path: "customer_tag",
        name: "customer_tag",
        component: () => import("@/views/trimo/customer/customer_tag.vue"),

        //参数
        meta: {
          noCache: true,
          title: "客服标签",
          routeList: ["/adm/customer/tag/list"],
        },
      },

      //客服标签
      {
        //基本信息
        path: "customer_tag_user",
        name: "customer_tag_user",
        component: () => import("@/views/trimo/customer/customer_tag_user.vue"),

        //参数
        meta: {
          noCache: true,
          title: "客服标签用户",
          routeList: ["/adm/customer/tag/list", "/adm/customer/tag/user/list"],
        },
      },

      //客服标签
      {
        //基本信息
        path: "customer_comment",
        name: "customer_comment",
        component: () => import("@/views/trimo/customer/customer_comment.vue"),

        //参数
        meta: {
          noCache: true,
          title: "客服评价",
          routeList: ["/adm/customer/comment/type", "/adm/customer/comment/list", "/adm/customer/comment/export", "/adm/customer/comment/edit"],
        },
      },
    ],
  },

  //装扮管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/zhuangban",
    redirect: "/trimo/zhuangban/zb_model",

    //参数
    meta: {
      //基本信息
      icon: "zhuangban",
      title: "装扮管理",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //装扮模型
      {
        //基本信息
        path: "zb_model",
        name: "zb_model",
        component: () => import("@/views/trimo/zhuangban/zb_model.vue"),

        //参数
        meta: {
          noCache: true,
          title: "装扮模型",
          routeList: ["/adm/zb/part/list", "/adm/zb/model/list"],
        },
      },

      //装扮等级
      {
        //基本信息
        path: "zb_level",
        name: "zb_level",
        component: () => import("@/views/trimo/zhuangban/zb_level.vue"),

        //参数
        meta: {
          noCache: true,
          title: "装扮等级",
          routeList: ["/adm/zb/level/list"],
        },
      },

      //装扮道具
      {
        //基本信息
        path: "zb_prop",
        name: "zb_prop",
        component: () => import("@/views/trimo/zhuangban/zb_prop.vue"),

        //参数
        meta: {
          noCache: true,
          title: "装扮道具",
          routeList: ["/adm/zb/cfg/all", "/adm/zb/prop/list"],
        },
      },

      //装扮道具发放
      {
        //基本信息
        path: "zb_prop_send",
        name: "zb_prop_send",
        component: () => import("@/views/trimo/zhuangban/zb_prop_send.vue"),

        //参数
        meta: {
          noCache: true,
          title: "装扮道具发放",
          routeList: ["/adm/zb/prop/list", "/adm/zb/prop/send/log"],
        },
      },

      //装扮背包道具
      {
        //基本信息
        path: "zb_user_pack",
        name: "zb_user_pack",
        component: () => import("@/views/trimo/zhuangban/zb_user_pack.vue"),

        //参数
        meta: {
          noCache: true,
          title: "装扮背包道具",
          routeList: ["/adm/zb/user/pack/list"],
        },
      },
    ],
  },

  //漂流瓶
  {
    //基本信息
    component: Layout,
    path: "/trimo/bottle",
    redirect: "/trimo/bottle/bottle_list",

    //参数
    meta: {
      //基本信息
      title: "漂流瓶",
      roles: ["admin"],
      alwaysShow: true,
      icon: "wish_bottle",
    },

    //子页面
    children: [
      //漂流瓶列表
      {
        //基本信息
        path: "bottle_list",
        name: "bottle_list",
        component: () => import("@/views/trimo/bottle/bottle_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "漂流瓶列表",
          routeList: ["/adm/wish/bottle/list"],
        },
      },

      //拾取列表
      {
        //基本信息
        path: "picker_list",
        name: "picker_list",
        component: () => import("@/views/trimo/bottle/picker_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "拾取列表",
          routeList: ["/adm/wish/bottle/pick/list"],
        },
      },
    ],
  },

  //系统设置
  {
    //基本信息
    component: Layout,
    path: "/trimo/system",
    redirect: "/trimo/system/ranking",

    //参数
    meta: {
      //基本信息
      icon: "system",
      title: "系统设置",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //排行榜
      {
        //基本信息
        path: "ranking",
        name: "ranking",
        component: () => import("@/views/trimo/system/ranking.vue"),

        //参数
        meta: {
          noCache: true,
          title: "排行榜",
          routeList: ["/adm/system/rank/list"],
        },
      },

      //默认消息
      {
        //基本信息
        path: "default_msg",
        name: "default_msg",
        component: () => import("@/views/trimo/system/default_msg.vue"),

        //参数
        meta: {
          noCache: true,
          title: "默认消息",
          routeList: ["/adm/system/default/msg/list"],
        },
      },

      //融云推送
      {
        //基本信息
        path: "ry_push",
        name: "ry_push",
        component: () => import("@/views/trimo/system/ry_push.vue"),

        //参数
        meta: {
          noCache: true,
          title: "融云推送",
          routeList: ["/adm/system/ry/push/tpl/type", "/adm/system/ry/push/tpl/list"],
        },
      },

      //退出推荐
      {
        //基本信息
        path: "quit_commend",
        name: "quit_commend",
        component: () => import("@/views/trimo/system/quit_commend.vue"),

        //参数
        meta: {
          noCache: true,
          title: "退出推荐",
          routeList: ["/adm/quit/commend/list"],
        },
      },

      //开机图片
      {
        //基本信息
        path: "boot_image",
        name: "boot_image",
        component: () => import("@/views/trimo/system/boot_image.vue"),

        //参数
        meta: {
          noCache: true,
          title: "开机图片",
          routeList: ["/adm/system/boot/image/list"],
        },
      },

      //系统分类
      {
        //基本信息
        path: "category",
        name: "category",
        component: () => import("@/views/trimo/system/category.vue"),

        //参数
        meta: {
          noCache: true,
          title: "系统分类",
          routeList: ["/adm/system/category/list"],
        },
      },

      //敏感词管理
      {
        //基本信息
        path: "words",
        name: "words",
        component: () => import("@/views/trimo/system/words.vue"),

        //参数
        meta: {
          noCache: true,
          title: "敏感词管理",
          routeList: ["/adm/system/words/category", "/adm/system/words/list"],
        },
      },

      //黑白名单管理
      {
        //基本信息
        path: "acl",
        name: "acl",
        component: () => import("@/views/trimo/system/acl.vue"),

        //参数
        meta: {
          noCache: true,
          title: "黑白名单管理",
          routeList: ["/adm/system/acl/list", "/adm/system/acl/save", "/adm/system/acl/remove", "/adm/system/acl/log/list"],
        },
      },
    ],
  },

  //守护勋章管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/medal",
    redirect: "/trimo/medal/systematics_list",

    //参数
    meta: {
      //基本信息
      icon: "medal",
      title: "守护勋章管理",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //分类列表
      {
        //基本信息
        path: "systematics_list",
        name: "systematics_list",
        component: () => import("@/views/trimo/medal/systematics_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "分类列表",
          routeList: ["/adm/medal/category/list"],
        },
      },

      //勋章列表
      {
        //基本信息
        path: "medal_list",
        name: "medal_list",
        component: () => import("@/views/trimo/medal/medal_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "勋章列表",
          routeList: ["/adm/medal/category/search", "/adm/medal/list"],
        },
      },

      //勋章发放
      {
        //基本信息
        path: "medal_send",
        name: "medal_send",
        component: () => import("@/views/trimo/medal/medal_send.vue"),

        //参数
        meta: {
          noCache: true,
          title: "勋章发放",
          routeList: ["/adm/medal/search", "/adm/medal/user/list"],
        },
      },
    ],
  },

  //系统管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/setting",
    redirect: "/trimo/setting/operation_log",

    //参数
    meta: {
      //基本信息
      icon: "nested",
      title: "系统管理",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //操作日志查询
      {
        //基本信息
        path: "operation_log",
        name: "operation_log",
        component: () => import("@/views/trimo/setting/operation_log.vue"),

        //参数
        meta: {
          noCache: true,
          title: "操作日志查询",
          routeList: ["/adm/manage/logComment", "/adm/manage/log"],
        },
      },
    ],
  },

  //亲密度管理
  {
    //基本信息
    component: Layout,
    path: "/trimo/intimacy",
    redirect: "/trimo/intimacy/intimacy_list",

    //参数
    meta: {
      //基本信息
      icon: "intimacy",
      title: "亲密度管理",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //亲密度列表
      {
        //基本信息
        path: "intimacy_list",
        name: "intimacy_list",
        component: () => import("@/views/trimo/intimacy/intimacy_list.vue"),

        //参数
        meta: {
          noCache: true,
          title: "亲密度列表",
          routeList: ["/adm/intimacy/list"],
        },
      },

      //亲密度记录
      {
        //基本信息
        path: "intimacy_log",
        name: "intimacy_log",
        component: () => import("@/views/trimo/intimacy/intimacy_log.vue"),

        //参数
        meta: {
          noCache: true,
          title: "亲密度记录",
          routeList: ["/adm/intimacy/log/list"],
        },
      },
    ],
  },

  //排行榜
  {
    //基本信息
    component: Layout,
    path: "/trimo/ranking",
    redirect: "/trimo/ranking/user_ranking",

    //参数
    meta: {
      //基本信息
      icon: "ranking",
      title: "排行榜",
      roles: ["admin"],
      alwaysShow: true,
    },

    //子页面
    children: [
      //用户排行榜
      {
        //基本信息
        path: "user_ranking",
        name: "user_ranking",
        component: () => import("@/views/trimo/ranking/user_ranking.vue"),

        //参数
        meta: {
          noCache: true,
          title: "用户排行榜",
          routeList: ["/adm/rank/user/list"],
        },
      },
    ],
  },

  //404页面
  {
    path: "*",
    redirect: "/404",
    meta: { hidden: true },
  },
];

/**
 * 基础路由(没有权限要求)
 */
export const constantRoutes: RouteConfig[] = [
  //重定向
  {
    path: "/redirect",
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/base/redirect/index.vue"),
      },
    ],
  },

  //登录界面
  {
    path: "/login",
    meta: { hidden: true },
    component: () => import("@/views/base/login/index.vue"),
  },

  //自动重定向
  {
    path: "/auth-redirect",
    meta: { hidden: true },
    component: () => import("@/views/base/login/auth-redirect.vue"),
  },

  //刷新界面
  {
    path: "/refresh",
    meta: { hidden: true },
    component: () => import("@/views/base/error-page/refresh.vue"),
  },

  //404界面
  {
    path: "/404",
    meta: { hidden: true },
    component: () => import("@/views/base/error-page/404.vue"),
  },

  //401界面
  {
    path: "/401",
    meta: { hidden: true },
    component: () => import("@/views/base/error-page/401.vue"),
  },

  //个人中心
  {
    path: "/profile",
    component: Layout,
    redirect: "/profile/index",
    meta: { hidden: true },
    children: [
      {
        path: "index",
        name: "Profile",
        component: () => import("@/views/base/profile/index.vue"),
        meta: { title: "个人中心", icon: "user", noCache: true },
      },
    ],
  },
];

//-------------------------- 调用函数 --------------------------
//创建路由
const createRouter = () =>
  new VueRouter({
    //创建路由
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    },

    //基础路由
    routes: constantRoutes,

    //基础路径
    base: process.env.BASE_URL,
  });

//初始化路由
const router = createRouter();

//重置路由
export function resetRouter() {
  //初始化路由
  const newRouter = createRouter();

  //重置路由
  (router as any).matcher = (newRouter as any).matcher;
}

//更新动态路由
export const updateAsyncRoutes = () => {};

//导出
export default router;
